<div class="wrapper">
  <ng-progress [spinner]="false" id="progressBar" [color]="'#040303'" [thick]="true"></ng-progress>
  <!-- sidebar -->
  <sidebar [ouItems]="ouItems" class="main-sidebar" #sidebarComponent id="main_sidebar"></sidebar>
  <!-- navbar -->
  <navbar class="main-navbar"></navbar>
  <main id="main-content">
    <div *ngIf="cambi" id="testoScorrevole">
      <div class="ticker-text">{{cambi}}</div>
    </div>
    <!-- container principale -->
    <div id="route-container" class="route_container" [ngClass]="sidebarComponent.isMinimized() && deviceDetector.isDesktop() ? 'mainWidth-minimized'
          : (deviceDetector.isDesktop() ? 'mainWidth-normal' : 'w-100')">
      <spinner></spinner>
      <div class="container-fluid" id="route-content">
        <router-outlet></router-outlet>
      </div>
    </div>
    <!-- footer -->
    <div class="app-footer">
      <span class="ml-auto">
        <span class="ml-auto">Version {{storageService.getItem('appVersion')}}</span> &nbsp;&nbsp;
        Powered by <a href="https://www.e-projectsrl.it/" target="_blank"
          class="font-weight-bold text-primary">e-project s.r.l.</a>
      </span>
    </div>
  </main>
  <div id="blockScreen" class="overlay" (click)="closeSidebar()"></div>
</div>
<div *ngIf="urlLoaded" style="height: 0px;">
  <img [src]="this.imgUrl" style="height: 0px; width: 0px;" (load)="loadQlikObjects()" />
</div>